module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "authors-note"
    }
  }, [_c('h1', [_vm._v("Author’s Note")]), _vm._v(" "), _c('p', [_vm._v("My aim in writing this story is to encourage young people to follow their dreams. The importance of self-confidence is paramount and often under-estimated in life.")]), _vm._v(" "), _c('p', [_vm._v("Many of the people in this book are based on real people; Jack McCulloch on Jack McNab. The account of events are as accurate as I can make them; although, not necessarily in the correct order.")]), _vm._v(" "), _c('p', [_vm._v("However, I have tried to portray the language and attitudes of the time as a good comparison from today.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a49197e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch006.vue
// module id = 78
// module chunks = 0